export const ROLES = {
  ADMINISTRATOR: 2,
  AUDITOR: 9,
  MID_LEVEL_REVIEWER: 5,
  PHYSICIAN_ADVISOR: 4,
  SUPPORT: 8,
  SYSTEM_ADMINISTRATOR: 1,
  TEAM_LEAD: 3,
  TRAINEE: 7,
  TRAINER: 6,
};

export const REVIEW_STATUSES = {
  FINAL: 3,
  IN_PROGRESS: 1,
  PENDING: 2,
};

export const REVIEW_STATUSES_STRING = {
  COMPLETED: 'Completed',
  IN_PROGRESS: 'In Progress',
  PENDING: 'Pending',
};

export const CPB_REVIEW_STATUSES_STRING_BY_ID = {
  0: '',
  1: 'In Progress',
  2: 'Pending',
  3: '',
};

export const REVIEW_TYPES = {
  APPEAL_RETROSPECTIVE: 4,
  CONTINUED_STAY: 2,
  CONTINUED_STAY_PA_REVIEW: 7,
  EMERGENCY_DEPARTMENT: 14,
  ESCALATE_FOR_PEER_TO_PEER: 8,
  ESCALATE_FOR_XSOLIS_PEER_TO_PEER: 11,
  FINAL_STATUS: 10,
  INITIAL: 1,
  INITIAL_PA_REVIEW: 3,
  MANUAL: 99,
  PA_TASK_RESOLUTION: 6,
  PAYER_AUDIT: 15,
  PAYER_REVIEW: 13,
  PEER_TO_PEER: 9,
  PEER_TO_PEER_XSOLIS_PA: 12,
  XSOLIS_INTERNAL: 5,
};

export const REVIEW_SYSTEM_NAMES = {
  APPEAL_RETROSPECTIVE: 'ART',
  APPEAL_RETROSPECTIVE_PA: 'PA_ART',
  AUTO_ASSIGN_TO_PAYER: 'AAP',
  CONTINUED_STAY: 'CST',
  CONTINUED_STAY_PA_REVIEW: 'PA_CST',
  EMERGENCY_DEPARTMENT: 'EDP',
  ESCALATE_FOR_PEER_TO_PEER: 'EPP',
  FINAL_STATUS: 'FST',
  INITIAL: 'INT',
  INITIAL_PA: 'PA_INT',
  PA_TASK_RESOLUTION: 'PAR',
  PAYER_REVIEW: 'AU_PYR',
  PEER_TO_PEER: 'PA_PTP',
  PEER_TO_PEER_TASK_RESOLUTION: 'PPR',
  PEER_TO_PEER_XSOLIS_PA: 'PA_PPX',
  XSOLIS_INTERNAL: 'XIN',
};

export const REVIEW_TYPES_RR_STRING = {
  APPEAL_RETROSPECTIVE: 'Appeal/Retrospective',
  APPEAL_RETROSPECTIVE_PA: 'Appeal/Retrospective PA',
  AUTO_ASSIGN_TO_PAYER: 'Auto-Assign To Payer',
  CONTINUED_STAY: 'Continued Stay',
  CONTINUED_STAY_PA: 'Continued Stay PA',
  EMERGENCY_DEPARTMENT: 'Emergency Department',
  ESCALATE_FOR_PEER_TO_PEER: 'Escalate for Peer-to-Peer',
  FINAL_STATUS: 'Final Status',
  INITIAL: 'Initial',
  INITIAL_PA: 'Initial PA Review',
  PA_TASK_RESOLUTION: 'PA Task Resolution',
  PEER_TO_PEER_PA: 'Peer-to-Peer PA',
  PEER_TO_PEER_TASK_RESOLUTION: 'Peer-To-Peer Task Resolution',
  PEER_TO_PEER_XSOLIS_PA: 'Peer-to-Peer XSOLIS PA',
  XSOLIS_INTERNAL: 'XSOLIS Internal',
};

export const REVIEW_TYPES_UI_STRING = {
  APPEAL_RETROSPECTIVE: 'Appeal/Retrospective',
  APPEAL_RETROSPECTIVE_PA: 'Appeal/Retrospective',
  AUTO_ASSIGN_TO_PAYER: 'Auto-Assign To Payer',
  CONTINUED_STAY: 'Continued Stay',
  CONTINUED_STAY_PA: 'Continued Stay PA Review',
  EMERGENCY_DEPARTMENT: 'Emergency Department',
  ESCALATE_FOR_PEER_TO_PEER: 'Escalate for Peer-to-Peer',
  FINAL_STATUS: 'Final Status',
  INITIAL: 'Initial',
  INITIAL_PA: 'Initial PA Review',
  PA_TASK_RESOLUTION: 'PA Task Resolution',
  PEER_TO_PEER: 'Peer-to-Peer',
  PEER_TO_PEER_PA: 'Peer-to-Peer',
  PEER_TO_PEER_TASK_RESOLUTION: 'Peer-To-Peer Task Resolution',
  PEER_TO_PEER_XSOLIS_PA: 'Peer-to-Peer XSOLIS PA',
  XSOLIS_INTERNAL: 'XSOLIS Internal',
};

export const ADMISSION_STATUSES_RR_STRING = {
  EXTENDED_RECOVERY: 'Extended Recovery',
  INPATIENT: 'Inpatient',
  OBSERVATION: 'Observation',
  OUTPATIENT: 'Outpatient',
  UNABLE_TO_DETERMINE: 'Unable to Determine',
};

export const XSOLIS_USER_TYPE = 1;

export const CLINICAL_CATEGORIES = {
  ABG: 'ABG',
  CARDIAC: 'Cardiac',
  CBC: 'CBC',
  CMP: 'CMP',
  COMORBIDITIES_OR_PAST_MEDICAL_HISTORY: 'ComorbiditiesOrPastMedicalHistory',
  CURRENT_HEALTH_INDICATORS: 'CurrentHealthIndicators',
  ENDOCRINE: 'Endocrine',
  HIGH_RISK_HOME_MEDICATIONS: 'HighRiskHomeMedications',
  OTHER: 'Other',
  VITAL_SIGNS: 'VitalSigns',
};

export const MAX_REFERRAL_COMMENT_LENGTH = 250;
export const AUTOSAVE_INTERVAL_MS = 300;
export const AUTOSAVE_DRAGONFLY_INTERVAL_MS = 20000;
export const COMMENT_AUTOSAVE_INTERVAL = 1000;
export const QA_TEST_USERNAME = 'cortex-pa-automation-test@xsolis.com';
export const USER_TYPES_KEY = 'user-types';
export const SYSTEM_ADM = 'System Administrator';

export const FEATURES = {
  ADMIN_USER_TYPE_ORGANIZATION: 'admin_user_type_organization',
  EVENT_REVIEW_AUTOSAVE: 'event_review_autosave',
  MERLOT_REVIEW_AUTOSAVE: 'review_autosave',
  PAM_CONNECTION: 'pa_merlot_connection',
  PAM_PARITY: 'pa_merlot_parity',
  PARR_INTEROPERABILITY: 'parr_interoperability',
  PARR_PARITY: 'pa_roadrunner_parity',
  PATIENT_EVENT_QUEUE: 'patient_event_queue',
  QUEUE_PA_STATUS_INDICATOR_P2P: 'queue_pa_status_indicator_p2p',
  TEAMS_CREATE_NEW_USER_TYPE_AND_NEW_USER:
    'teams_create_new_user_type_and_new_user',
};

export const STEPS = {
  ROLES: 2,
  USER_DETAILS: 1,
};

export const P2P_OUTCOME_TYPES = {
  DECLINED_P2P: 4,
  DENIAL_OVERTURNED: 6,
  DENIAL_UPHELD_FORMAL_APPEAL: 7,
  DENIAL_UPHELD_STATUS_DOWNGRADE: 8,
  OVERTURNED: 1,
  P2P_NOT_PERFORMED: 5,
  P2P_NOT_PERFORMED_NO_RESPONSE_APPEAL: 13,
  P2P_NOT_PERFORMED_NO_RESPONSE_NO_APPEAL: 14,
  P2P_NOT_PERFORMED_NOT_OFFERED: 9,
  P2P_NOT_PERFORMED_OVERTURNED_CLINICAL: 12,
  P2P_NOT_PERFORMED_PHYSICIAN_REFUSED: 11,
  P2P_NOT_PERFORMED_RECOMMEND_OUTPATIENT_OBSERVATION: 10,
  PENDED: 3,
  UPHELD: 2,
};

export const PAYER_TYPE_CODES = {
  MEDICAID: 'MC',
  MEDICARE_ADVANTAGE: 'MV',
  MEDICARE_PART_A: 'MA',
  MEDICARE_PART_B: 'MB',
};

export const CURRENT_PATIENT_STATUSES = {
  DISCHARGED: 5,
  DISCHARGED_MO: 9,
  EMERGENCY: 3,
  INPATIENT: 1,
  INPATIENT_MO: 7,
  OBSERVATION: 4,
  OBSERVATION_MO: 8,
  OUTPATIENT: 2,
  PREADMIT: 10,
  REGISTRATION: 6,
};

export const REVIEW_CASE_STATUSES = {
  CORRECT: 1,
  INPATIENT: 11,
};

export const REVIEW_2ND_LEVEL_REASONS = {
  P2P_CONSIDERATION: 'Peer-to-Peer Consideration',
};

export const REVIEW_TYPES_REQUESTED = {
  APPEAL_RETROSPECTIVE: 'Appeal/Retrospective',
  MANUAL: 'Manual',
  P2P: 'Peer-to-Peer',
  STATUS_DETERMINATION: 'Status Determination',
};

export const LEVELS_OF_CARE = {
  INPATIENT_CS: 8,
  INPATIENT_I: 1,
  INSUFFICIENT_CS: 11,
  INSUFFICIENT_I: 4,
  OBSERVATION_CS: 9,
  OBSERVATION_I: 2,
  OUTPATIENT_CS: 10,
  OUTPATIENT_I: 3,
};

export const FINDINGS = {
  REQUEST_PA_P2P_CS: 202,
  REQUEST_PA_P2P_I: 201,
};

export const CHANGE_REVIEW_TYPE_MESSAGE = `Changing the review type will delete the review in progress and create a new review of the chosen type. Any content that can be transferred to the new review will be. This cannot be undone.`;

export const CANCEL_CHANGES_MESSAGE =
  'All changes you have made to this review will be discarded.';

export const REVIEW_WILL_BE_DELETED_MESSAGE =
  'You have changed the Review type for this review and selected Cancel. Are you sure you want to continue?  Selecting YES will DELETE this review, including all content. Selecting NO will return you to the review, where you may proceed with your change or edit the Review type.';

export const REVIEW_TYPE_SYSTEM_NAMES_UR_POP = [
  REVIEW_SYSTEM_NAMES.INITIAL,
  REVIEW_SYSTEM_NAMES.CONTINUED_STAY,
  REVIEW_SYSTEM_NAMES.APPEAL_RETROSPECTIVE,
  REVIEW_SYSTEM_NAMES.ESCALATE_FOR_PEER_TO_PEER,
];

export const REVIEW_TYPE_SYSTEM_NAMES_PA_POP = [
  REVIEW_SYSTEM_NAMES.INITIAL_PA,
  REVIEW_SYSTEM_NAMES.CONTINUED_STAY_PA_REVIEW,
  REVIEW_SYSTEM_NAMES.APPEAL_RETROSPECTIVE_PA,
  REVIEW_SYSTEM_NAMES.PEER_TO_PEER,
];

export const REVIEW_TYPE_SYSTEM_NAMES_PAYER_POP = [
  REVIEW_SYSTEM_NAMES.PAYER_REVIEW,
];

export const FONT_SIZE_MULTIPLIER_SETTINGS = {
  MAX: 5,
  MIN: 0,
};

export const FONT_SIZE_MULTIPLIER_OPTIONS = [
  { key: 'DEFAULT', text: 'DEFAULT', value: 0 },
  { key: '2X', text: '2X', value: 1 },
  { key: '3X', text: '3X', value: 2 },
  { key: '4X', text: '4X', value: 3 },
  { key: '5X', text: '5X', value: 4 },
  { key: '6X', text: '6X', value: 5 },
];

export const STORAGE_KEYS = {
  lastInvoiceParams: 'lastInvoiceParams',
  recentlyViewColumns: 'recently-view-columns',
};

export const DESKTOP_BREAKPOINT = 1180;

export const REVIEW_TYPE_SYSTEM_NAMES_UR = [
  REVIEW_SYSTEM_NAMES.PA_TASK_RESOLUTION,
  REVIEW_SYSTEM_NAMES.PEER_TO_PEER_TASK_RESOLUTION,
  REVIEW_SYSTEM_NAMES.EMERGENCY_DEPARTMENT,
  REVIEW_SYSTEM_NAMES.INITIAL,
  REVIEW_SYSTEM_NAMES.CONTINUED_STAY,
  REVIEW_SYSTEM_NAMES.ESCALATE_FOR_PEER_TO_PEER,
  REVIEW_SYSTEM_NAMES.FINAL_STATUS,
  REVIEW_SYSTEM_NAMES.APPEAL_RETROSPECTIVE,
  REVIEW_SYSTEM_NAMES.XSOLIS_INTERNAL,
  REVIEW_SYSTEM_NAMES.PAYER_REVIEW,
  REVIEW_SYSTEM_NAMES.AUTO_ASSIGN_TO_PAYER,
];
